import { render, staticRenderFns } from "./roomView.vue?vue&type=template&id=68bfe139&scoped=true"
import script from "./roomView.vue?vue&type=script&lang=js"
export * from "./roomView.vue?vue&type=script&lang=js"
import style0 from "./roomView.vue?vue&type=style&index=0&id=68bfe139&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bfe139",
  null
  
)

export default component.exports